import { defineMessages } from 'react-intl-next';

export default defineMessages({
	customPageNameTextLabel: {
		defaultMessage: 'Page name',
		description: 'Custom page name text field label',
		id: 'create.custom.page.name.text.field.label.title',
	},
	customPageNameTextFieldPlaceholder: {
		defaultMessage: 'Enter a page name',
		description: 'Custom page name text field placeholder',
		id: 'create.custom.page.name.text.field.placeholder.title',
	},
	customPageDescriptionTextLabel: {
		defaultMessage: 'Page description',
		description: 'Custom page description field label',
		id: 'create.custom.page.description.text.field.label.title',
	},
	customPageDescriptionInfoTooltip: {
		defaultMessage:
			'Appears in help hub search results and when this page is linked elsewhere.',
		description: 'Custom page description text info tooltip',
		id: 'create.custom.page.description.text.field.info.tooltip',
	},
	customPageDescriptionInfoTooltipLabel: {
		defaultMessage: 'Landing page description info',
		description: 'Custom page description text info icon label',
		id: 'create.custom.page.description.text.field.info.tooltip.label',
	},
	customPageDescriptionTextFieldPlaceholder: {
		defaultMessage: 'Enter a page description',
		description: 'Custom page description text field placeholder',
		id: 'create.custom.page.name.description.field.placeholder.title',
	},
	customPageNameRequiredError: {
		defaultMessage: 'Enter a name for your page.',
		description: 'Validation error message when custom page name is empty',
		id: 'create.custom.page.name.required.validation.error',
	},
	customPageNameCharacterLimitError: {
		defaultMessage: 'Enter a page name with {value} characters or less.',
		description:
			'Validation error message when custom page name is greater than required limit',
		id: 'create.custom.page.name.character.limit.validation.error',
	},
	customPageDescriptionCharacterLimitError: {
		defaultMessage: 'Enter a page description with {value} characters or less.',
		description:
			'Validation error message when custom page description is greater than required limit',
		id: 'create.custom.page.description.character.limit.validation.error',
	},
});
